import { render, staticRenderFns } from "./PortalCompanyNavigation.vue?vue&type=template&id=1258328a&"
import script from "./PortalCompanyNavigation.vue?vue&type=script&lang=js&"
export * from "./PortalCompanyNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports